var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { class: ["sal-accordion", _vm.show ? "open" : ""] }, [
    _c(
      "div",
      { class: ["sal-accordion--header"], on: { click: _vm.toggle } },
      [
        _c("div", { class: ["icon-toggle", _vm.show ? "minus" : "plus"] }, [
          _c("span", { staticClass: "vertical" }),
          _vm._v(" "),
          _c("span", { staticClass: "horizontal" }),
        ]),
        _vm._v(" "),
        _vm._t("header"),
      ],
      2
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.show,
            expression: "show",
          },
        ],
        staticClass: "sal-accordion--body",
      },
      [_vm._t("body")],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }